"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingCategoryType = exports.TrackingCategoryFrequency = exports.EnvelopeType = exports.ExcludeReason = void 0;
var ExcludeReason;
(function (ExcludeReason) {
    ExcludeReason["Logic"] = "logic";
    ExcludeReason["CustomerRule"] = "customer_rule";
    ExcludeReason["LoanExclusion"] = "loanExclusion";
    ExcludeReason["RelativeIncomeExclusion"] = "relativeIncomeExclusion";
    ExcludeReason["HighIncomeExclusion"] = "highIncomeExclusion";
    ExcludeReason["DefaultExclusion"] = "defaultExclusion";
})(ExcludeReason = exports.ExcludeReason || (exports.ExcludeReason = {}));
var EnvelopeType;
(function (EnvelopeType) {
    EnvelopeType["Economy"] = "economy";
    EnvelopeType["Fixed"] = "fixed";
    EnvelopeType["TrackingCategory"] = "trackingCategory";
    EnvelopeType["RiseUpGoal"] = "riseupGoal";
    EnvelopeType["Variable"] = "variable";
    EnvelopeType["RollingCredit"] = "rollingCredit";
    EnvelopeType["VariableIncome"] = "variableIncome";
    EnvelopeType["Saving"] = "saving";
    EnvelopeType["Recurring"] = "recurring";
})(EnvelopeType = exports.EnvelopeType || (exports.EnvelopeType = {}));
var TrackingCategoryFrequency;
(function (TrackingCategoryFrequency) {
    TrackingCategoryFrequency["Weekly"] = "weekly";
    TrackingCategoryFrequency["Monthly"] = "monthly";
})(TrackingCategoryFrequency = exports.TrackingCategoryFrequency || (exports.TrackingCategoryFrequency = {}));
var TrackingCategoryType;
(function (TrackingCategoryType) {
    TrackingCategoryType["Custom"] = "custom";
    TrackingCategoryType["Saving"] = "saving";
})(TrackingCategoryType = exports.TrackingCategoryType || (exports.TrackingCategoryType = {}));
//# sourceMappingURL=enums.js.map